import { Component, OnInit } from '@angular/core';
import { subject } from 'src/app/service/modal/subject';
import { SubjectService } from 'src/app/service/apiservice/subject.service';
import { Globals } from '../../../globals';
import { Router } from '@angular/router';
declare function info_noti(msg: any): any;
declare var $;
@Component({
  selector: 'app-subject',
  templateUrl: './subject.component.html',
  styleUrls: ['./subject.component.css']
})
export class SubjectComponent implements OnInit {

  subjectGrid: subject[] = new Array();

  constructor(private router:Router, private _subjectService: SubjectService, private global: Globals) { }

  ngOnInit() {
    // this.global.afterRefreshPageSetToken();
    localStorage.setItem("Active Route",this.router.url);
    this.GetSubject_List();
  }


  GetSubject_List() {
    this._subjectService.GetSubjectList()
      .subscribe((response) => {
        Object.assign(this.subjectGrid, response);
        
      },
        error => {
          info_noti(error);
        })
  }

 

}

